
<div class="text-center" *ngIf="splash">
    <img src="../assets/logo.png" height="128" style="margin-top:100px">
    <h3>C1 Management</h3>
    <p>{{splashMessage}}</p>
</div>


<div class="wrapper" [class.blur]="privacy" *ngIf="!splash && currentIsLogin==true" >
  <!-- <div class="wrapper" [class.blur]="privacy" *ngIf="currentIsLogin==true" [style.background-color]="config.softwarecolor" ></div> -->

    <!-- Navbar -->
    <nav class="main-header navbar navbar-expand navbar-light elevation-0">
      <ul class="navbar-nav" *ngIf="menu.length>1">
        <li class="nav-item">
          <img *ngIf="config.softwareicon && config.softwareicon!=''" class="d-md-none d-inline-block" style="height: 2rem" src="{{config.softwareicon}}">
          <a class="nav-link pushmenu d-inline-block" data-widget="pushmenu" href="#" title="Scopri/Nascondi menu">
            <i class="fas fa-bars" ></i>
          </a>
        </li>
        <li class="nav-item">
          <div class="menu-title">
            {{current_module.label}}
            <span *ngIf="currentUser.isAdmin() && current_module && current_module.settingwindow" class="p-1 pointer text-xs" (click)="openModuleSettingWindow()"><i class="fa fa-cog" title="Personalizzazioni"></i></span>
          </div>
        </li>
        <!-- <li class="nav-item" *ngIf="current_module && current_module.settingwindow">
          <a class="nav-link" (click)="openModuleSettingWindow()"><i class="fa fa-cog" title="Personalizzazioni"></i></a>
        </li> -->
      </ul>
      <!-- <div class="navbar-nav" >
          <h5 class="text-secondary m-0"><b>{{title}}</b></h5>
          <button *ngIf="current_module && current_module.settingwindow" class="btn btn-xs btn-default" (click)="openModuleSettingWindow()"><i class="fa fa-cog"></i></button>
          <h5 class="text-secondary m-0" *ngIf="history.length > 0"><b>{{history[history.length-1].label}}</b></h5>
      </div> -->
      <ul class="navbar-nav ml-auto mr-1">
         <!-- Shop -->
        <li class="nav-item" *ngIf="currentUser['shop']" >
          <span class="nav-link" title="{{currentUser['shop']['name']}}" >
            <div class="d-inline-flex align-items-center justify-content-center">
                <i class="fas fa-store-alt mr-1"></i>
                <span style="max-width:80px;" class="mb-0 d-none d-sm-inline-block text-xs text-truncate">{{currentUser['shop']['name']}}</span>
              </div>
          </span>
        </li>
        <!-- Account -->
        <li class="nav-item dropdown">
          <a class="nav-link" data-toggle="dropdown" href="#" title="{{currentUser.name}}" >
            <div class="d-inline-flex align-items-center justify-content-center">
              <div class="rounded-circle d-inline-flex align-items-center justify-content-center bg-dark text-uppercase mr-1" style="height:1.25rem; width:1.25rem">{{currentUser.name[0]}}</div>
              <span style="max-width:80px;" class="mb-0 d-none d-sm-inline-block text-xs text-truncate">{{currentUser.name}}</span><br/>      
            </div>
          </a>         
          <div class="dropdown-menu dropdown-menu-lg dropdown-menu-right p-0">
            <div class="card mb-0">
                <div class="card-header bg-dark text-center p-2 text-xs">ACCOUNT</div>
                <!-- <div class="card-header alert-secondary text-center text-xs p-2" style="line-height: 12px;">
                  <b style="max-width:150px;" class="mb-0 text-truncate">{{currentUser.username}}</b><br>
                  <small class="text-uppercase text-xs"><small>{{currentUser.role}}</small></small>
                </div> -->
                <div class="card-body p-0">                  
                  <button type="button" (click)="openModalUserInfo(currentUser)" class="dropdown-item"><i class="fas fa-id-card mr-2"></i><small>I tuoi dati</small>
                    <small style="max-width:150px; font-size:7pt" class="d-block d-sm-none text-uppercase text-truncate">{{currentUser.name}}</small>
                  </button>
                  <div class="dropdown-divider"></div>
                  <ng-container *ngIf="enableSelectPoint">
                    <button type="button" (click)="openSelectPoint()" class="dropdown-item"><i class="fas fa-house-user mr-2"></i><small>Cambia sede di lavoro</small>
                      <small style="max-width:150px; font-size:7pt" class="d-block d-sm-none text-uppercase text-truncate" *ngIf="currentUser['shop']">{{currentUser['shop']['name']}}</small>
                    </button>
                    <div class="dropdown-divider"></div>
                  </ng-container>                  
                  <button type="button" (click)="logout()" class="dropdown-item"><i class="fas fa-user-times mr-2"></i><small>Logout</small></button>
                </div>
            </div>
          </div>
        </li>
         <!-- Connector -->
        <li class="nav-item" style="color: rgba(0, 0, 0, 0.5)"  *ngIf="enableC1Connector">
          <span class="nav-link py-0" style="cursor: pointer" title="{{c1connector_status?'Connesso':'Non connesso'}} ">
            <i [class.text-success]="c1connector_status" class="fas fa-network-wired pr-2"></i><br>
              <span class="float-left" style="font-size:7pt">{{c1connector_c1connectorid}}</span>
          </span>
        </li>
        <!-- Alarm -->
        <li class="nav-item dropdown">
          <app-alarm></app-alarm>
        </li>
         <!-- Chat -->
         <li class="nav-item dropdown" *ngIf="enableChat">
          <app-chat></app-chat>
        </li>
        <!-- Impostazioni -->
        <li class="nav-item dropdown" *ngIf="menu_settings.length>0" >
          <a class="nav-link" data-toggle="dropdown" href="#" aria-expanded="false" title="Impostazioni">
            <i class="fas fa-cogs"></i>
          </a>
          <div class="dropdown-menu dropdown-menu-lg dropdown-menu-right p-0">
            <div class="card mb-0">
              <div class="card-header bg-dark text-center p-2 text-xs">IMPOSTAZIONI</div>
              <div class="card-body p-0">
                <ng-container *ngFor="let m of menu_settings"  >
                  <a (click)="goToView(m)" class="pointer dropdown-item"><i class="{{m.icon}} mr-2"></i><small>{{m.label}}</small></a>
                  <!-- <div class="dropdown-divider"></div> -->
                </ng-container>
              </div>
             </div>
          </div>
        </li>
      </ul>
    </nav>
    <!-- /Navbar -->

    <!-- Sidebar -->
    <aside class="main-sidebar sidebar-no-expand sidebar-light-primary position-fixed" >  <!-- sidebar-dark-primary sidebar-no-expand-->
      <p class="brand-link mb-0">
        <img *ngIf="config.softwareicon && config.softwareicon!=''" alt="logo" class="brand-image" src="{{config.softwareicon}}">
        <span class="brand-text text-truncate d-inline-block" title="{{config.softwarename}}">{{config.softwarename}}</span>
        <a class="close_sidebar d-block d-lg-none float-right" data-widget="pushmenu" href="#" ><i class="fas fa-times"></i></a>
      </p>
      <div class="sidebar">
        <nav class="mt-2">
          <ul class="nav nav-sidebar flex-column" [class.nav-compact]="menu && menu.length>10" data-widget="treeview" role="menu" data-accordion="false"> <!-- per comprimere: nav-compact -->
              <li class="nav-item" *ngFor="let m of menu" >
                  <a class="d-none d-lg-block nav-link" (click)="goToView(m)" [class.active]="m==current_module" >
                    <i class="nav-icon {{m.icon}} mr-2" title="{{m.label}}"></i>
                    <p>{{m.label}}</p>
                    <small *ngIf="currentUser.isAdmin() && m==current_module && current_module && current_module.settingwindow" class="cog_button pointer float-right" (click)="openModuleSettingWindow()">
                      <i class="fa fa-cog" title="Personalizzazioni"></i></small>
                  </a>
                  <a class="d-block d-lg-none nav-link" (click)="goToView(m)" [class.active]="m==current_module" data-widget="pushmenu" > <!-- per auto-nascondersi data-widget="pushmenu"  -->
                    <i class="nav-icon {{m.icon}} mr-2"></i><p>{{m.label}}</p>
                  </a>
              </li>
              <li class="nav-item" *ngIf="current_module && current_module.type==2">
                  <a class="d-none d-lg-block nav-link active">
                    <i class="nav-icon {{current_module.icon}} mr-2" title="{{current_module.label}}"></i>
                    <p>{{current_module.label}}</p>
                  </a>
              </li>
          </ul>
        </nav>
      </div>
    </aside>
    <!-- /Sidebar -->

    <div id="sidebar-overlay">
      <!-- <a class="close_sidebar d-block d-lg-none" data-widget="pushmenu" href="#" ><i class="fas fa-times"></i></a> -->
    </div>

    <!-- Content Wrapper -->
    <div class="content-wrapper px-2 pb-3" > <!--style="margin-top:56px;"-->
        <router-outlet></router-outlet>
        <div>
          <!-- Use ng-template to ensure that the generated components end up in the right place -->
          <ng-template #mainContent></ng-template>
        </div>
    </div>
    <!-- / Content Wrapper -->
  
    <!-- Footer -->
    <footer class="main-footer d-none d-sm-inline-block fixed-bottom text-xs elevation-1" >
      <!-- <footer class="main-footer d-none d-sm-inline-block fixed-bottom text-xs elevation-1" [style.background-color]="config.softwarecolor" > -->
      <div class="float-left mx-2"><b class="text-primary">C1</b></div>
      <div class="float-left mr-5 pointer"  title="Changelog (Premi CTRL+F5 per aggiornare)" (click)="openModalChangeLog()">versione {{version}} ({{build}})</div>
      <ng-container *ngIf="company.name && copyright">
        <div class="float-left mr-5 d-none d-lg-block">is a <a href="http://codingict.it" target="_blank">Coding</a> software</div>
        <div (click)="openModalRegistrationInfo()" title="Dati di registrazione" class="float-right d-none d-sm-inline-block ml-5 mr-2 pointer">Licenza:&ensp;<span class="text-primary">{{company.name}}</span></div>
        <div (click)="openModalRegistrationInfo()" title="Dati di registrazione" class="float-right ml-5 d-none d-lg-block pointer">Scadenza: <span [class.text-primary]="!readonly" [class.blink]="readonly" [class.text-danger]="readonly">{{config.expired_license | date:"dd/MM/yyyy"}}</span></div>
      </ng-container>
      <div class="float-left mr-5" *ngIf="loadingstatusbar"><i class="fas fa-spinner fa-spin mr-2"></i>{{loadingstatusbarmessage}}</div>            
      <div *ngIf="currentUser.isSuperUser()" class="float-right d-none d-sm-inline-block ml-5" (dblclick)="privacy==false?privacy=true:privacy=false">
        <i class="fa-server fa mr-1"></i><span class="text-primary">{{config.serverUrl}}</span>
        <i *ngIf="privacy" title="Modalità privacy attiva" class="fa fa-eye-slash ml-2"></i>
      </div>
      <div class="float-right ml-5 d-none d-lg-block">
        <i class="fa-hdd far mr-1"></i>
        <span class="text-primary" title="Spazio occupato">{{total_occupied_space}}B</span>
        <span *ngIf="total_space" title="Spazio totale"> / {{total_space}}GB</span>
      </div>
    </footer>
  <!-- /Footer -->

</div>


<ng-template #modalUserInfo let-modal>
  <div class="modal-header">
    <span><i class="fas fa-user-tie mr-3"></i>I tuo dati</span>
</div>
  <div class="modal-body p-4">
    <div class="rounded-circle d-flex align-items-center justify-content-center bg-purple float-right text-uppercase p-2" style="height:6rem; width:6rem; font-size: 3rem;" title="{{currentUser.name}} ">{{currentUser.name[0]}}</div>
    <!-- <i class="fas fa-user-circle float-right text-light fa-8x mr-3"></i>     -->
    <p>Nominativo:<br><b>{{currentUser.name}}</b><br><i>{{currentUser.email}}</i></p>
    <p>Nome utente:<br><b>{{currentUser.username}}</b></p>   
    <p>Ruolo utente:<br>
      <ng-container *ngFor="let ug of usergroups">
          <span *ngIf="currentUser.role==ug.name" >
            <b>{{ug.title}}</b><br>
            <small><i>{{ug.description}}</i></small>
          </span>
      </ng-container>
    </p>
    <ng-container *ngIf="showInputPassword" >
      <form>
        Password:
        <div class="input-group input-group-sm">
          <input class="form-control form-control-sm" type="password" name="inputPassword" #type="ngModel" placeholder="inserisci nuova password..."  [(ngModel)]="currentUser.password">
          <div class="input-group-append input-group-append-sm">
              <span class="input-group-text input-group-text-sm"><i class="fa fa-key"></i></span>
          </div>
        </div>
      </form>
      <button (click)="changePassword(currentUser)" class="btn btn-outline-success btn-block mt-2">Salva password</button>
    </ng-container>
    <div class="text-center mt-4">
      <button *ngIf="!showInputPassword" (click)="showInputPassword=true" class="btn btn-outline-info btn-block">Cambia password</button>
      <button (click)="modal.close('cancel')" class="btn btn-outline-secondary btn-block"><i class="fas fa-times mr-1"></i>Chiudi</button>
    </div>
  </div>
</ng-template>


<ng-template #modalRegistrationInfo let-modal>
  <div class="modal-header">
    <b><i class="fas fa-key mr-3"></i>Dati di registrazione</b>
</div>
  <div class="modal-body p-4">
    <p class="text-center">
      <b class="text-primary" style="font-size:5rem">C1</b><br>
      <small>Versione {{version}} build: {{build}}</small>
    </p>
    <hr><br>
    <p>
      Concesso in licenza a:<br>
      <b>{{company.name}}</b><br>
      <small>{{company.address}}</small><br>
      <small>{{company.zip}} {{company.city}} {{company.country}}</small><br>
      <small *ngIf="company.vat_number"> P.IVA: {{company.vat_number}}</small>
    </p>    
    <p>
      Scadenza:<br>
      <b>{{config.expired_license | date:"dd/MM/yyyy"}}</b>
    </p>
    <p>
      Stato licenza:<br> 
      <b *ngIf="!readonly" [class.text-success]="true">ATTIVA</b>
      <b *ngIf="readonly" [class.text-danger]="true">NON ATTIVA</b><small *ngIf="readonly"> (solo lettura dati)</small>
    </p>
    <!--
    <p>Dettagli:</p>
    <small style="line-height:0rem;">
      <p>- Spazio di archiviazione: <b>{{total_space}}Gb</b></p>
      <p>- Utenti: <b>1</b></p>
      <p>- Sedi: <b>1</b></p>
      <p>- Magazzini: <b>1</b></p>
      <p>- Prodotti: max <b>1000</b></p>
      <p>- Documenti: max <b>1000</b></p>
    </small>
    -->
    <div class="text-center mt-5">
      <button (click)="modal.close('cancel')" class="btn btn-outline-secondary btn-block"><i class="fas fa-times mr-1"></i>Chiudi</button>
    </div>
  </div>
</ng-template>


<ng-template #modalChangeLog let-modal>
  <div class="modal-header">
    <b><i class="fas fa-bug mr-3"></i>ChangeLog</b>
</div>
  <div class="modal-body text-xs">
    <div style="max-height:60vh; overflow:auto">
      <div class="m-4 text-center text-secondary">
          <i class="icon fas fa-info-circle mr-2"></i>
          <i>Non sei sicurə di visualizzare la versione più aggiornata? Premi <b>CTRL + F5</b> per aggiornare.</i>
          <i>(su MAC premi: <b>Comando (⌘) + Maiuscole (⇧) + R</b>)</i>
      </div>
      <ng-container *ngFor="let cl of changeLog">
        <div class="card m-1">
          <div class="card-header py-1">
            Versione: {{cl.version}} &ensp; Build: {{cl.build}}
          </div>
          <div class="card-body py-1">
            <small>
              <ng-container *ngFor="let l of cl.log">
                  <b>{{l.module}}</b><br>
                  <ng-container *ngFor="let lr of l.log">
                    - {{lr}}<br>
                  </ng-container>
              </ng-container>
            </small>
          </div>
        </div>
      </ng-container>
    </div>    
  </div>
  <div class="modal-footer">
    <button (click)="modal.close('cancel')" class="btn btn-primary btn-block"><i class="fas fa-times mr-1"></i>Chiudi</button>
  </div>
</ng-template>


<ng-container *ngIf="loading">
  <div class="loading"></div>
  <div class="spinner text-white">
    <div class="text-center">
      <h1>C1</h1>
      <!-- <i class="fas fa-satellite-dish fa-3x"></i><br> -->
      Scaricamento...
    </div>   
    <div class="spinner-border"  role="status" >
      <span class="sr-only">Loading...</span>
    </div>    
  </div>
</ng-container>


<!-- <ngx-loading [show]="loading" [config]="{ backdropBorderRadius: '3px' }"></ngx-loading> -->